<template>
    <div class="inspiration-container">
        <div class="inspiration-title">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="320" zoomAndPan="magnify" viewBox="0 0 810 176.249993" preserveAspectRatio="xMidYMid meet" version="1.0"><defs><g/></defs><g fill="#000000" fill-opacity="1"><g transform="translate(255.87779, 105.545519)"><g><path d="M 21.804688 -49.9375 C 37.652344 -54.371094 45.429688 -36.925781 45.429688 -36.925781 L 45.429688 -44.484375 C 45.429688 -44.484375 37.871094 -54.878906 21.660156 -50.445312 C 7.921875 -46.8125 -0.144531 -32.5625 3.417969 -18.753906 C 7.339844 -4.941406 21.152344 3.417969 35.035156 -0.582031 C 40.269531 -1.960938 44.921875 -4.941406 48.121094 -8.941406 L 48.121094 -18.171875 C 47.101562 -10.320312 42.957031 -3.125 34.890625 -0.945312 C 22.535156 2.398438 12.066406 -9.085938 9.011719 -20.207031 C 6.25 -31.257812 9.375 -46.519531 21.804688 -49.9375 Z M 21.804688 -49.9375 "/></g></g></g><g fill="#000000" fill-opacity="1"><g transform="translate(306.539327, 105.545519)"><g><path d="M 33.292969 -10.757812 C 30.601562 -3.417969 26.894531 -0.582031 20.644531 -0.582031 L 8.359375 -0.582031 L 8.359375 -51.316406 L 2.542969 -51.316406 L 2.542969 0 L 31.546875 0 Z M 33.292969 -10.757812 "/></g></g></g><g fill="#000000" fill-opacity="1"><g transform="translate(342.373098, 105.545519)"><g><path d="M 2.542969 0 L 7.996094 0 L 7.996094 -51.316406 L 2.542969 -51.316406 Z M 2.542969 0 "/></g></g></g><g fill="#000000" fill-opacity="1"><g transform="translate(352.912445, 105.545519)"><g><path d="M 8.140625 -34.234375 C 10.25 -25.660156 18.972656 -26.09375 23.1875 -21.296875 L 23.1875 -27.039062 C 13.230469 -27.039062 8.140625 -29.074219 8.140625 -39.035156 L 8.140625 -50.808594 L 14.101562 -50.808594 C 22.96875 -50.808594 26.75 -50.445312 31.910156 -45.503906 L 31.910156 -51.316406 L 2.542969 -51.316406 L 2.542969 0 L 31.472656 0 L 33.144531 -10.757812 C 30.527344 -3.417969 26.75 -0.582031 20.425781 -0.582031 L 8.140625 -0.582031 Z M 8.140625 -34.234375 "/></g></g></g><g fill="#000000" fill-opacity="1"><g transform="translate(388.60085, 105.545519)"><g><path d="M 2.542969 -51.316406 L 2.542969 0 L 7.996094 0 L 7.996094 -50.808594 C 15.847656 -50.808594 21.660156 -44.921875 26.023438 -36.636719 C 31.402344 -26.09375 34.089844 -11.558594 34.089844 0 L 39.542969 0 L 39.542969 -51.316406 L 34.089844 -51.316406 L 34.089844 -9.59375 C 33 -18.972656 30.601562 -29.003906 26.3125 -36.925781 C 22.097656 -45.359375 15.917969 -51.316406 7.996094 -51.316406 Z M 2.542969 -51.316406 "/></g></g></g><g fill="#000000" fill-opacity="1"><g transform="translate(430.685532, 105.545519)"><g><path d="M 19.84375 0 L 25.441406 0 L 25.441406 -50.808594 C 33.144531 -50.738281 37.796875 -50.300781 42.742188 -45.722656 L 42.742188 -51.390625 L 2.542969 -51.390625 L 2.542969 -45.722656 C 7.339844 -50.300781 12.066406 -50.738281 19.84375 -50.808594 Z M 19.84375 0 "/></g></g></g><g fill="#000000" fill-opacity="1"><g transform="translate(475.968357, 105.545519)"><g><path d="M 8.140625 -34.234375 C 10.25 -25.660156 18.972656 -26.09375 23.1875 -21.296875 L 23.1875 -27.039062 C 13.230469 -27.039062 8.140625 -29.074219 8.140625 -39.035156 L 8.140625 -50.808594 L 14.101562 -50.808594 C 22.96875 -50.808594 26.75 -50.445312 31.910156 -45.503906 L 31.910156 -51.316406 L 2.542969 -51.316406 L 2.542969 0 L 31.472656 0 L 33.144531 -10.757812 C 30.527344 -3.417969 26.75 -0.582031 20.425781 -0.582031 L 8.140625 -0.582031 Z M 8.140625 -34.234375 "/></g></g></g><g fill="#000000" fill-opacity="1"><g transform="translate(511.656771, 105.545519)"><g><path d="M 6.25 -38.960938 C 6.25 -30.675781 13.882812 -26.53125 21.660156 -23.042969 C 38.597656 -15.265625 39.90625 -7.777344 35.109375 -3.78125 C 25.949219 3.925781 9.667969 -2.398438 2.542969 -20.425781 L 2.542969 -10.320312 C 10.757812 0.21875 27.402344 3.125 35.691406 -3.199219 C 38.308594 -5.304688 39.90625 -8.359375 39.90625 -12.285156 C 39.90625 -20.863281 32.347656 -25.003906 24.421875 -28.421875 C 6.6875 -36.707031 6.105469 -44.703125 11.777344 -48.410156 C 18.460938 -53.0625 31.691406 -51.972656 39.035156 -37.070312 L 39.035156 -44.703125 C 32.78125 -54.808594 6.25 -55.171875 6.25 -38.960938 Z M 6.25 -38.960938 "/></g></g></g></svg>
        </div>
        <div class="inspiration-cards">
            <div class="inspiration-row">
                <div class="inspiration-card-container">
                    <div class="inspiration-card card1">

                    </div>
                    <p class="inspiration-text">
                        <i>Menina Step EU</i>
                    </p>
                </div>
                <div class="inspiration-card-container">
                    <div class="inspiration-card card2" >
                        
                    </div>
                    <p class="inspiration-text">
                        <i>Elite Pilates</i>
                    </p>
                </div>
            </div>
            <div class="inspiration-row">
                <div class="inspiration-card-container">
                    <div class="inspiration-card card3">
                        
                    </div>
                    <p class="inspiration-text">
                        <i>Castellano LG</i>
                    </p>
                </div>

                <div class="inspiration-card-container">
                    <div class="inspiration-card card4">
                        
                    </div>
                    <p class="inspiration-text">
                        <i>Menina Step USA</i>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Inspiration'
}
</script>

<style scoped>
.inspiration-container {
    height: 80%;
    padding: 10%;
}
.inspiration-cards{
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
}
.inspiration-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    height: 40%;
    justify-content: space-between;
    padding: 10% 5%;
    box-sizing: border-box;
}

.inspiration-card-container {
    width: 48%;
    box-sizing: border-box;
}

.inspiration-card {
    border: 1px solid black;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
}

.inspiration-text {
    font-size: 1vh;
    text-align: left;
}

.inspiration-title {
    padding-top: 20px;
}

.card1 {
    background-image: url("../assets/inspo2.png");
}

.card2 {
    background-image: url("../assets/inspo4.png");
}

.card3 {
    background-image: url("../assets/inspo3.png");
}

.card4 {
    background-image: url("../assets/inspo1.png");
}
</style>
  